import { Grid } from '@mui/material';
import Button from 'components/Button';
import ButtonGroup from 'components/ButtonGroup';
import Heading, { HeadingProps } from 'components/Heading';
import { styled } from '@mui/material';

type HoldingClassHeaderProps = {
  newHoldingClasses: boolean;
  hasInvestments: boolean;
  handleCancel: () => void;
  handleAddHoldingClass: () => void;
  onRevalueClick: () => void;
};

const ResponsiveHeading = styled(Heading)<HeadingProps>(
  ({ theme, noMargin }) => ({
    [theme.breakpoints.down('lg')]: {
      '& > div': {
        ...(noMargin && {
          marginBottom: theme.spacing(2),
        }),
      },
    },
  }),
);

const TooltipWrapper = styled('div')({
  display: 'block',
  width: '100%',
});

const HoldingClassHeader: React.FC<HoldingClassHeaderProps> = ({
  newHoldingClasses,
  handleCancel,
  handleAddHoldingClass,
  onRevalueClick,
  hasInvestments,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ lg: 6, md: 12, xs: 12 }} alignContent="center">
        <ResponsiveHeading variant="h2" noMargin>
          Holdings overview
        </ResponsiveHeading>
      </Grid>
      <Grid size={{ lg: 6, md: 12, xs: 12 }}>
        <ButtonGroup sx={{ justifyContent: 'flex-end' }}>
          <TooltipWrapper>
            <Button
              variant="contained"
              fullWidth
              onClick={onRevalueClick}
              disabled={!hasInvestments}
              tooltip={
                !hasInvestments
                  ? 'There are currently no units held. Please make an investment before revaluing units.'
                  : undefined
              }
            >
              Revalue company
            </Button>
          </TooltipWrapper>
          {newHoldingClasses ? (
            <Button
              variant="contained"
              fullWidth
              color="error"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          ) : (
            <Button
              variant="contained"
              fullWidth
              color="primary"
              onClick={handleAddHoldingClass}
            >
              Add new holding class
            </Button>
          )}
        </ButtonGroup>
      </Grid>
    </Grid>
  );
};

export default HoldingClassHeader;
